import React from "react";
import { Menu, Icon } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import "./AdminMenu.scss";

export function AdminMenu() {
  const { pathname } = useLocation();

  // Corrige la destructuración para acceder al objeto user anidado
  const { user } = useAuth(); // Extrae el objeto user completo de useAuth
  const role = user?.user?.role; // Accede al role a través del objeto user anidado

  //console.log(role); // Imprime el role para verificar que se está accediendo correctamente

  const isAdmin = role === "admin"; // Verifica si el role es 'admin'
  const isClient = role === "client";
  const isUser = role === "user";
  const isPartner = role === "partner";
  const isInstitution = role === "institution";
  //const isTeacher = role === "teacher";
  //const isStudent = role === "student";

  //console.log('ADMIN', role); // Imprime si es admin

  const isCurrentPath = (path) => {
    return pathname === path; // Simplifica la función de comparación
  };

  return (
    <Menu fluid vertical icon text className="admin-menu">
      {isAdmin && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/users"
            active={isCurrentPath("/admin/users")}
          >
            <Icon name="user" />
            Usuarios
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/planes"
            active={isCurrentPath("/admin/planes")}
          >
            <Icon name="cart arrow down" />
            Planes
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/billings"
            active={isCurrentPath("/admin/billings")}
          >
            <Icon name="money bill alternate" />
            Facturación
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/blog"
            active={isCurrentPath("/admin/blog")}
          >
            <Icon name="comment alternate" />
            Blog
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/menu"
            active={isCurrentPath("/admin/menu")}
          >
            <Icon name="bars" />
            Menu
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/courses"
            active={isCurrentPath("/admin/courses")}
          >
            <Icon name="computer" />
            Cursos Educa Jobs
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/newsletter"
            active={isCurrentPath("/admin/newsletter")}
          >
            <Icon name="mail" />
            Newsletter
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/salas"
            active={isCurrentPath("/admin/salas")}
          >
            <Icon name="object group" />
            Salas Mozilla Hubs
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/virtualscenes"
            active={isCurrentPath("/admin/virtualscenes")}
          >
            <Icon name="accusoft" />
            Virtual Scenes
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/assistance"
            active={isCurrentPath("/admin/assistance")}
          >
            <Icon name="id badge" />
            Asistentes virtuales
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/clientdbcreator"
            active={isCurrentPath("/admin/clientdbcreator")}
          >
            <Icon name="address card" />
            Clientes DB
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/usersdb"
            active={isCurrentPath("/admin/usersdb")}
          >
            <Icon name="address book" />
            Usuarios Cursos
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/tiptap-test"
            active={isCurrentPath("/admin/tiptap-test")}
          >
            <Icon name="align center" />
            Tiptap Test
          </Menu.Item>
        </>
      )}
      {isClient && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/clientdb"
            active={isCurrentPath("/admin/clientdb")}
          >
            <Icon name="address card" />
            Clientes DB
          </Menu.Item>

          <Menu.Item
            as={Link}
            to="/admin/blog"
            active={isCurrentPath("/admin/blog")}
          >
            <Icon name="comment alternate" />
            Blog
          </Menu.Item>
        </>
      )}

      {isUser && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/blog"
            active={isCurrentPath("/admin/blog")}
          >
            <Icon name="comment alternate" />
            Blog
          </Menu.Item>
        </>
      )}

      {isPartner && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/register"
            active={isCurrentPath("/admin/register")}
          >
            <Icon name="clipboard" />
            Profile
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/institution"
            active={isCurrentPath("/admin/institution")}
          >
            <Icon name="building outline" />
            Institution
          </Menu.Item>
        </>
      )}
      {isInstitution && (
        <>
          <Menu.Item
            as={Link}
            to="/admin/inst/profile"
            active={isCurrentPath("/admin/inst/profile")}
          >
            <Icon name="university" />
            Institución
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/inst/teachers"
            active={isCurrentPath("/admin/inst/teachers")}
          >
            <Icon name="user" />
            Docentes
          </Menu.Item>
        </>
      )}
    </Menu>
  );
}
